import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './Config/app/i18n';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RouterProvider } from 'react-router-dom';
import { AnalyticsProvider } from 'use-analytics';
import { entryQueryClientConfig } from './Config/api/entryQueryClient.config';
import { PUBLIC_KEY_V3 } from './Config/app/reCaptcha';
import router from './Config/app/router/entry.router';
import analytics from './Config/libs/analytics';
import './Domain/style/app.scss';
import './Config/api/httpClient.config';

if (!document.getElementById('entry')) {
  throw new Error('Entry point not found');
}

const root = createRoot(document.getElementById('entry') as HTMLElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={entryQueryClientConfig}>
      <AnalyticsProvider instance={analytics}>
        <GoogleReCaptchaProvider reCaptchaKey={PUBLIC_KEY_V3}>
          <RouterProvider router={router} />
        </GoogleReCaptchaProvider>
      </AnalyticsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
